import React, { useState, useLayoutEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import DefaultLayout from '../../components/layout/DefaultLayout';
import Loader from '../../components/layout/Loader';
import { showLoader, hideLoader } from '../../store/slices/loadingSlice';
import DecomptesService from '../../api/decomptes/services/DecomptesService';
import DecomptesFilters from "../../components/extranet/decomptes/DecomptesFilters";
import DecomptesTable from "../../components/extranet/decomptes/DecomptesTable";
import DetailsDialog from "../../components/extranet/decomptes/DecomptesDetailsDialog";

const DecomptesPage = () => {
    const now = new Date().toISOString().slice(0, 10);
    const [filters, setFilters] = useState({ from: '', to: now, min: '', max: '' });
    const [rows, setRows] = useState([]);
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);
    const [detailRows, setDetailRows] = useState([]);

    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();
    const loading = useSelector(state => state.loading.value);
    const selectedCodeCompany = useSelector(state => state.extranet.selectedCodeCompany);
    const account = useSelector(state => state.account);

    const fetchDecomptes = async (payload) => {
        dispatch(showLoader());
        try {
            const res = await DecomptesService.getListDecomptes(keycloak.token, {
                destinataire: account.user.codeConnexion,
                destinataireType: account.user.type === 'ENTREPRISE' ? 'E' : 'A',
                dateDebut: payload.from,
                dateFin: payload.to,
                montantMin: payload.min,
                montantMax: payload.max,
            });
            setRows(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            dispatch(hideLoader());
        }
    };

    useLayoutEffect(() => {
        fetchDecomptes(filters).finally();
    }, [selectedCodeCompany]);

    const handleSearch = () => fetchDecomptes(filters);
    const handleReset = () => {
        const reset = { from: '', to: now, min: '', max: '' };
        setFilters(reset);
        fetchDecomptes(reset).finally();
    };

    const handleViewDetails = async (id) => {
        dispatch(showLoader());
        try {
            const res = await DecomptesService.getDecompteDetails(keycloak.token, id);
            setDetailRows(res.data);
            setDetailDialogOpen(true);
        } catch (err) {
            console.error(err);
        } finally {
            dispatch(hideLoader());
        }
    };

    const theme = useTheme();

    return (
        <DefaultLayout>
            <Loader open={loading} />
            <DecomptesFilters
                filters={filters}
                onChange={setFilters}
                onSearch={handleSearch}
                onReset={handleReset}
            />
            <DecomptesTable
                rows={rows}
                onViewDetails={handleViewDetails}
            />
            <DetailsDialog
                open={detailDialogOpen}
                onClose={() => setDetailDialogOpen(false)}
                rows={detailRows}
                theme={theme}
            />
        </DefaultLayout>
    );
};

export default DecomptesPage;